<h2 mat-dialog-title>Compartilhar empreendimento!</h2>
<div mat-dialog-content>
  <div class="share-wrapper">
    <a
      class="share-item"
      [cdkCopyToClipboard]="
        'https://www.immobile.digital/empreendimento/' +
        data.empreendimento?.slug
      "
      (click)="dialogRef.close()"
    >
      <i class="far fa-copy"></i>
      <span>Copiar link</span>
    </a>
    <a class="share-item" (click)="shareLink('facebook')">
      <i class="fab fa-facebook-f"></i>
      <span>Facebook</span>
    </a>
    <a class="share-item" (click)="shareLink('whatsapp')">
      <i class="fab fa-whatsapp"></i>
      <span>Whatsapp</span>
    </a>
    <a class="share-item" (click)="shareLink('linkedin')">
      <i class="fab fa-linkedin-in"></i>
      <span>Linkedin</span>
    </a>
    <a class="share-item" (click)="shareLink('twitter')">
      <i class="fab fa-twitter"></i>
      <span>Twitter</span>
    </a>
    <a class="share-item" (click)="shareLink('mail')">
      <i class="far fa-envelope"></i>
      <span>Email</span>
    </a>
  </div>
</div>
